import { render, staticRenderFns } from "./inlandOrderInfo.vue?vue&type=template&id=c067f508&scoped=true&"
import script from "./inlandOrderInfo.vue?vue&type=script&lang=js&"
export * from "./inlandOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./inlandOrderInfo.vue?vue&type=style&index=0&id=c067f508&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c067f508",
  null
  
)

export default component.exports